export default {
  title: 'Détails de livraison',
  buttons: {
    save: 'Enregistrer',
  },
};
